import axios from "axios"
export const IMPORTPRODUCTLOG_URL = `${process.env.REACT_APP_API_URL}/importProductLogs`
export const getImportLogs = async () => {
  const response = await axios.get(`${IMPORTPRODUCTLOG_URL}/getimportproductlogs`)
  return response.data
}